import { ajax } from "./ajax";

export const serialize = function(form) {
  // Setup our serialized data
  var serialized = [];

  // Loop through each field in the form
  for (var i = 0; i < form.elements.length; i++) {
    var field = form.elements[i];

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (
      !field.name ||
      field.disabled ||
      field.type === "file" ||
      field.type === "reset" ||
      field.type === "submit" ||
      field.type === "button"
    )
      continue;

    // If a multi-select, get all selections
    if (field.type === "select-multiple") {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push(
          encodeURIComponent(field.name) +
            "=" +
            encodeURIComponent(field.options[n].value)
        );
      }
    }

    // Convert field data to a query string
    else if (
      (field.type !== "checkbox" && field.type !== "radio") ||
      field.checked
    ) {
      serialized.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
      );
    }
  }

  return serialized.join("&");
};

export function getClosestParent(element, selector) {
  for (; element && element !== document; element = element.parentNode) {
    if (element.matches(selector)) return element;
  }
  return null;
}

export function accountPopupModals() {
  function handleModalClick(e) {
    e.preventDefault();
    getClosestParent(e.target, ".account-modal-popups").classList.add(
      "hide"
    );
  }
  function initialize() {
    document.querySelectorAll(".account-modal-popups").forEach(function(popup) {
      popup
        .querySelector(".closing-x")
        .addEventListener("click", handleModalClick);
    });

    document.addEventListener(
      "click",
      function(e) {
        if (e.target.closest(".account-modal-popups") && !e.target.closest('.callout')) {
          getClosestParent(e.target, ".account-modal-popups").classList.add(
            "hide"
          );
        }
      },
      false
    );

  }
  initialize();
}
accountPopupModals();

export function logout() {
  const url =
    window.location.protocol + "//" + window.location.host + "/account/login";
  const data = new FormData();

  ajax.get("/account/logout", data, function(response) {
    var html = document.createDocumentFragment();
    var div = document.createElement("div");

    div.innerHTML = response;
    html.appendChild(div);

    const errorStr = html.querySelector(".errors");
    if (errorStr) html.textContent.replace(/\s/g, "");

    if (errorStr) {
      document.querySelector(".error-request-modal").classList.remove("hide");
    } else {
      window.location.href = url;
    }
  });
}
